import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { deleteExtra } from '../api/extras';
import { customConfirm } from '../utils/utils';
import { getImageUrl } from '../api';
import { Button } from './Button';
import S from './ExtraItem.styl';
var ExtraItem = /** @class */ (function (_super) {
    __extends(ExtraItem, _super);
    function ExtraItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.deleteItem = function () {
            var i18n = _this.props.store.i18n;
            var extra = _this.props.extra;
            if (extra) {
                customConfirm(i18n.extrasDeleteSummary, _this.props.store, function (success) {
                    if (success) {
                        _this.setState({ loading: true });
                        var request = {
                            id: extra.id,
                        };
                        deleteExtra(request).then(function () {
                            _this.setState({ loading: false });
                            _this.isUpdated();
                        }).catch(function (error) {
                            _this.setState({ loading: false });
                            alert(error);
                        });
                    }
                });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.isEditClicked = function () {
            if (_this.props.isEditClicked) {
                _this.props.isEditClicked(_this.props.extra);
            }
        };
        return _this;
    }
    ExtraItem.prototype.componentDidMount = function () {
        // Did Mount
    };
    ExtraItem.prototype.render = function () {
        var props = this.props;
        var extra = props.extra;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.extraItem }, extra ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: S.tableCell + " imageCell" },
                    React.createElement("img", { src: getImageUrl(extra.image || '') })),
                React.createElement("div", { className: S.tableCell }, extra.title),
                React.createElement("div", { className: S.action },
                    React.createElement(Button, { className: S.updateButton, type: "button", onClick: this.isEditClicked }, i18n.actionUpdate),
                    React.createElement(Button, { className: S.deleteButton, type: "button", onClick: this.deleteItem }, i18n.actionDelete)))
            :
                React.createElement(React.Fragment, null)));
    };
    ExtraItem = __decorate([
        inject('store'),
        observer
    ], ExtraItem);
    return ExtraItem;
}(React.Component));
export { ExtraItem };
